import { API } from './resources'

export default {
  getNav: () => {
    return API.get('/navbar-item/view')
  },
  get: (id) => {
    return API.get(`/navbar-item/${id}`)
  },
  getAll: (data) => {
    return API.get('/navbar-item', { params: data })
  },
  getByEvent: (eventID) => {
    return API.get(`/navbar-item/event/${eventID}`)
  },
  create: (data) => {
    return API.post('/navbar-item', data)
  },
  update: (id, data) => {
    return API.put(`/navbar-item/${id}`, data)
  },
  delete: (id) => {
    return API.delete(`/navbar-item/${id}`)
  },
  addToEvent: (id, eventID) => {
    return API.post(`/navbar-item/${id}/event/${eventID}`)
  },
  updateNavbarSettings: (eventID, data) => {
    return API.put(`/navbar/event/${eventID}/settings`, data)
  },
  updateEventNavItem: (id, eventID, data) => {
    return API.put(`/navbar-item/${id}/event/${eventID}`, data)
  },
  removeFromEvent: (id, eventID) => {
    return API.delete(`/navbar-item/${id}/event/${eventID}`)
  }
}
